module.exports = __webpack_public_path__ + "icomoon.b3cb5eb.woff";